import { render, staticRenderFns } from "./Contact-list.vue?vue&type=template&id=8e6ec350&scoped=true&"
import script from "./Contact-list.vue?vue&type=script&lang=js&"
export * from "./Contact-list.vue?vue&type=script&lang=js&"
import style0 from "./Contact-list.vue?vue&type=style&index=0&id=8e6ec350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6ec350",
  null
  
)

export default component.exports